import useOrganizationController from '@admin/api/useOrganizationController'
import MainContainer from '@blocks/MainContainer'
import Resource from '@components/modules/Resource'
import useTitle from '@hooks/useTitle'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'
import OrganizationForm from './components/OrganizationForm'
import columns from './config/columns'

export default function OrganizationsPage() {
    const controller = useOrganizationController()

    useTitle("Organizations")
    useMainTemplate({ category: "organizations" })

    return (
        <MainContainer heading="Organizations">
            <Resource
                cache="admin:organizations"
                form={OrganizationForm}
                label="organization"
                controller={controller}
                columns={columns} />
        </MainContainer>
    )
}